<template>
    <div class="same_wrap">
        <p>已绑定图书馆的馆藏信息<b>{{ listdata.length }}</b>条</p>
        <div class="libslist" v-if="listdata.length > 0">
            <div class="list" v-for="(item, index) in listdata">
                <span>{{ item.orgName }}</span>
                <b>{{ item.num }} 册</b>
            </div>
        </div>        
        <div class="btn_box" style="padding-top:15px;text-align:right;">
            <el-button class="btn_add_sure" size="mini" type="primary" @click="ok">确定</el-button>
        </div>
    </div>
</template>
    
    <script>
    import Axios from "@/api/diyaxios";
        export default {
            props: ['gids'],
            components:{
                
            },
            data() {               
                return {
                    listdata: []
                }
            },
            mounted() {  
                let vm = this;    
                vm.getLibsList();   
            },
            methods:{
                getLibsList(){
                    let vm = this;
                    Axios.post('/col/action/get?goodsId='+vm.gids).then(res => {
                        if(res.code =='200'){
                            vm.listdata = res.data;
                        }
                        
                    }).catch(err => {

                    });
                },
                ok(){
                    this.$emit('sure');
                }
            }
        }
    </script>
    
    <style lang='scss'>
    .same_wrap{
        >p{
            line-height: 40px;
            font-size: 14px;
            >b{
                color:#2f70d4;
                margin:0px 3px;
            }
        }
        .libslist{
            padding:10px 25px;
            font-size:12px;
            border-top:1px solid #eee;
            border-bottom:1px solid #eee;
            >.list{
                line-height: 34px;
                border-bottom: 1px dashed #dddddd;
                >span{
                    display: inline-block;
                    width:50%;
                }
                >b{
                    display: inline-block;
                    width:30%;
                    color: rgb(177, 6, 6);
                }
                &:last-child{
                    border-bottom: 0px none;
                }
            }
        }
    }
    </style>


// WEBPACK FOOTER //
// src/components/colsInfo.vue